module.exports = (__parcel__import__("bftGx")).then(() => parcelRequire('4MKVl'));